import React from 'react';

import {
  AppFullScreenContainer,
  AppHeader,
  CompareList,
} from 'src/components';
import { useTranslations } from 'src/hooks/translataions';
import { useBuildType, useSetDocumentTitle } from 'src/hooks';
import { locals } from 'src/constants/locals';
import { FlatShowLogo } from 'src/components/FlatShowLogo';
import { useStyles } from './styles';

export const Compare: React.FC = () => {
  const styles = useStyles({});
  const { isCrossTable } = useBuildType();
  const { getTranslations } = useTranslations();
  useSetDocumentTitle(getTranslations(locals.appTranslations.appTitleCompare));

  return (
    <AppFullScreenContainer>
      <div className={styles.compareWrapper}>
        <AppHeader />
        <CompareList />
        { !isCrossTable && (
          <FlatShowLogo />
        )}
      </div>
    </AppFullScreenContainer>
  );
};
